import BaseService from './BaseService'

class CategoryService extends BaseService {
  constructor() {
    super('/categories')
  }

  async getTree({ nested = true } = {}) {
    const params = { nested }
    return this.customRequest('get', `/tree`, null, { params })
  }

  async moveCategory(categoryId, { parent_id = null, slug = null } = {}) {
    return this.customRequest('post', `/${categoryId}/move`, { parent_id, slug })
  }

  async reorderChildren(categoryId, orders) {
    return this.customRequest('post', `/${categoryId}/reorder`, { orders })
  }

  async uploadImage(categoryId, file) {
    const formData = new FormData()
    formData.append('image', file)
    return this.customRequest('post', `/${categoryId}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}

export const categoryService = new CategoryService()


